module.exports = __webpack_public_path__ + "static/img/3.34e9e81.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/2/sp/3.png
// module id = Rzma
// module chunks = 0